import { Box, Container } from "@mui/material";
import { SectionHeading } from "./SectionHeading";
import { ProductCards } from "./ProductCards";

export function ProductSection() {
  return (
    <Box
      component="section"
      sx={{
        bgcolor: "rgba(13, 4, 2, 0)",
        display: "flex",
        width: "100%",
        py: { xs: "80px", sm: "100px", md: "120px" }, // Responsive vertical padding
        px: { xs: "16px", sm: "32px", md: "80px" },   // Better control from 480px and up
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        "@media (max-height:645px)":{
            py:"110px",
          },
        mb: { xs: 6, md: 10 }, // bottom spacing after section for laptop
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          display: "flex",
          width: "100%",
          maxWidth: "1009px",
          flexDirection: "column",
          alignItems: "stretch",
        }}
      >
        <SectionHeading />
        <ProductCards />
      </Container>
    </Box>
  );
}
